import { Person } from "./common";
import { IDigitalAddress } from "./contact";
import { IPosition } from "./position";
import { IValueListLight } from "./valuelist";

export interface IIndividual extends Person {
  positionAssignmentId: number;
  individualId: number;
  positionId: number;
  positionName: string;
  honorificTitle?: string;
  individualFullName?: string;
  email: string;
  indStatus: string;
  indStatusReason: IValueListLight;
  assignmentType: string;
  relType: IValueListLight;
  startDate: string;
  acting: boolean;
  gender: IValueListLight;
  honorific: IValueListLight;
  x509: string;
  digitalAddresses: [IDigitalAddress];
}

export interface ISearchIndividualsForNewInput {
  orgId: number
  individualName: string
  positionName?: string
}

export interface IIndividualInput extends Person {
  genderId: number
  email?: string
  honorificId: number
  x509?: string
}

export interface IAssignIndividualInput {
  assignmentTypeId?: number
  positionId?: number
  individualId?: number
  reasonId?: number
  assignmentId?: number
  acting?: boolean
}

export interface IIndividualLight extends Person {
  individualId: number
  honorificTitle?: IValueListLight
  individualFullName?: string
  gender?: IValueListLight
  email: string
  positionAssignments?: [IPositionAssignment]
  acting: boolean
  id?: number
  relId?: number
  relTypeCode?: string
  relationshipType?: string
  positionId?: number
  positionTitle?: string
  positionFullName?: string
  organizationId: number
  organizationName: string
}

export interface IPositionAssignment {
  positionAssignmentId: number
  position: IPosition
  individual: IIndividualLight
  relType: IValueListLight
  assignmentStatusReason?: IValueListLight
  assignmentStatus?: IValueListLight
  startDate: string
  acting: boolean
}

export interface IPositionAssignmentLight {
  assignmentId: number
  positionId: number
  positionTitle: string
  fullPositionName: string
  individualId: number
  relationshipType: string
  relatedOrganization: string
  relatedOrganizationId: number
  isScope: boolean
  acting: boolean
  isRole: boolean
  isActive: boolean
  deactivationReason: string
}

export interface IUpdateResult {
  action: Action
  success: boolean
  code: string
  message: string
}

export interface IUpdateResultResponse {
  assignIndividual: IUpdateResult
}

export enum Action {
  ADD = "ADD",
  ADD_AUTOMATION = "ADD_AUTOMATION",
  ADD_VALIDATION = "ADD_VALIDATION",
  ACTIVATION = "ACTIVATION",
  ACTIVATION_AUTOMATION = "ACTIVATION_AUTOMATION",
  ACTIVATION_VALIDATION = "ACTIVATION_VALIDATION",
  DEACTIVATION = "DEACTIVATION",
  REMOVAL = "REMOVAL",
  REMOVAL_VALIDATION = "REMOVAL_VALIDATION",
  REMOVAL_AUTOMATION = "REMOVAL_AUTOMATION",
  EXPIRE = "EXPIRE",
  EXPIRE_VALIDATION = "EXPIRE_VALIDATION",
  UPDATE_REASON = "UPDATE_REASON",
  ACTING = "ACTING",
  ADD_RELATIONSHIP = "ADD_RELATIONSHIP",
  ADD_RELATIONSHIP_VALIDATION = "ADD_RELATIONSHIP_VALIDATION",
	MOVE_RELATIONSHIP ="MOVE_RELATIONSHIP",
	MOVE_RELATIONSHIP_VALIDATION ="MOVE_RELATIONSHIP_VALIDATION",
	REMOVE_RELATIONSHIP ="REMOVE_RELATIONSHIP",
	REMOVE_RELATIONSHIP_VALIDATION = "REMOVE_RELATIONSHIP_VALIDATION"
}

export interface IIndividualActingLinkAssignmentResponse {
  individualActingLinkAssignment: IPositionAssignmentLight[]
}

export interface IIndividualAssignmentsResponse {
  individualAssignments: IPositionAssignmentLight[]
}

export interface IPositionBasedAssignmentsResponse {
  searchPositionBasedIndividualAssignments: IPositionAssignmentLight[]
}

export interface ISearchIndividualInput {
  orgId: number;
  firstName: string;
  lastName: string;
  email: string;
}

export interface ISearchIndividualResult {
  individualId: number
  fullName: string;
  positionId?: number;
  title?: string;
  email?: string;
  positionRole?: string;
  role?: boolean;
  assignmentId?: number;
  assignment?: string;
  active?: boolean;
}

export interface ISearchIndividualResponse {
  searchIndividual: {
    individuals: ISearchIndividualResult[];
    message: string;
  }
}

export interface ISearchIndividualsForNewResult {
  individualId: number;
  fullName: string;
  restricted: string;
  active: boolean;
  primaryEmail: string;
  emails: IDigitalAddress[];
  assignments: IPositionAssignmentLight[];
}

export interface ISearchIndividualsForNewUserResponse {
  searchIndividualsForNewUser: {
    individuals: ISearchIndividualsForNewResult[];
    message: string;
  }
}

export interface ISearchIndividualsForNewAssignmentResponse {
  searchIndividualsForNewAssignment: {
    individuals: ISearchIndividualsForNewResult[];
    message: string;
  }
}

export interface IAddMembershipInput {
  orgId: number
  titleId: number
  type: string
  memberIds: number[]
  isInformalGrp: boolean
}

export interface IAssignMembershipResultResponse {
  assignMembership: IUpdateResult
}

export interface IPositionIndividual extends Person, IIndividualLight {
  id: number
  relId: number
  relTypeCode: string
  relationshipType: string
  positionId: number
  positionTitle: string
  positionFullName: string
  individualId: number
  individualName: string
  organizationId: number
  organizationName: string
}

export enum PositionMembershipTypes {
  PositionIndividual = "pos-ind",
  PositionPosition = "pos-pos"
}
